module.exports = __webpack_public_path__ + "img/sTaiga88_350x350.4ab4d7e2.jpg";